import {
    Box,
    Button,
    Divider,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
    VStack,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { useRef } from "react";
import * as Yup from "yup";

// Define validation schema
const profileSchema = Yup.object().shape({
    newNickname: Yup.string()
        .max(50, "First name must be less than 50 characters")
        .required("Nickname is required"),
});

const ChangeNicknameForm = ({ formRef, onClose}) => {
    return (
        <Formik
            innerRef={formRef}
            initialValues={{
                newNickname: "",
            }}
            validationSchema={profileSchema}
            onSubmit={(values, actions) => {
                setTimeout(() => {
                    alert(JSON.stringify(values, null, 2));
                    actions.setSubmitting(false);
                    onClose()
                }, 1000);
            }}
        >
            {({ isSubmitting }) => (
                <Form>
                    <Field name="newNickname">
                        {({ field, form }) => (
                            <FormControl
                                isInvalid={
                                    form.errors.newNickname &&
                                    form.touched.newNickname
                                }
                            >
                                <FormLabel>Enter a new nickname *</FormLabel>
                                <Input {...field} type="text" />
                                <FormErrorMessage>
                                    {form.errors.newNickname}
                                </FormErrorMessage>
                            </FormControl>
                        )}
                    </Field>
                </Form>
            )}
        </Formik>
    );
};

const ChangeNicknameModal = ({ isOpen, onOpen, onClose }) => {
    const formRef = useRef(); // Create a ref to access Formik

    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.handleSubmit(); // Trigger form submission
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            blockScrollOnMount={false}
            isCentered
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize={"md"}>Change nickname</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <ChangeNicknameForm formRef={formRef} onClose={onClose} />
                </ModalBody>

                <ModalFooter display={"flex"} gap={1}>
                    <Button variant={"danger-outline"} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Change my nickname
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

const Account = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    return (
        <VStack align={"flex-start"} gap={10} mb={25}>
            <Box width={"100%"}>
                <Heading size={"md"}>Change nickname</Heading>
                <Divider borderColor={"gray.300"} />
                <Text>
                    Changing your nickname can have unintended side effects.
                </Text>
                <Button variant={"outline"} onClick={onOpen}>
                    Change nickname
                </Button>
                <ChangeNicknameModal
                    isOpen={isOpen}
                    onOpen={onOpen}
                    onClose={onClose}
                />
            </Box>

            <Box width={"100%"}>
                <Heading size={"md"}>Export account data</Heading>
                <Divider borderColor={"gray.300"} />
                <Text>Export your profile metadata and your FQL history</Text>
                <Button variant={"outline"}>Start export</Button>
            </Box>

            <Box width={"100%"}>
                <Heading size={"md"}>Delete account</Heading>
                <Divider borderColor={"gray.300"} />
                <Text>This action is irreversible</Text>
                <Button variant={"danger-outline"}>Delete your account</Button>
            </Box>
        </VStack>
    );
};

export default Account;
